import { render, staticRenderFns } from "./TextMaster.vue?vue&type=template&id=4404d7a0"
import script from "./TextMaster.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextMaster.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TextMaster.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxFormInputQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Question.vue').default,IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,IxTextarea: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Textarea.vue').default,IxInfoCopyable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/info/Copyable.vue').default,IxFormInputCombobox: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Combobox.vue').default,IxFormInputCustomReferencePeriodPicker: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/CustomReferencePeriodPicker.vue').default,IxFormInputLargeOptions: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/LargeOptions.vue').default,IxFormInputSmallOptions: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/SmallOptions.vue').default})
